<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <admin-box-item :title="$route.query.title + ' 게시글 정보'">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="작성자">
                  <span>{{ post_username }}</span>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시글 노출기간">
                  <div class="flex" style="align-items:center">
                    <span>{{ value.start_date }}</span>
                    <span class="lp-dating" v-if="value.start_date || value.end_date">&#126;</span>
                    <span>{{ value.end_date }}</span>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시물 노출 여부">
                  <span v-if="value.enable_post">노출</span>
                  <span v-else>비노출</span>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="제목">
                  <span>{{ value.title }}</span>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용">
                  <lp-editor :text.sync="value.content" :disabled="true"></lp-editor>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시글 대표 이미지">
                  <div :style="'background-image: url('+ value.img +'); width: 60px; height: 60px; background-size: cover; background-position: center; margin-right: 12px'"></div>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="맞춤 DB">
            <div class="columns is-multiline">
              <div class="column is-full"
                   style="position: relative"
                   v-for="(param, index) in post_param"
                   v-bind:key="'param_input'+index">
                <div style="position: absolute; left: 0; top: 0; bottom: 0; right: 0; z-index: 100"></div>
                <admin-form-item :label="param.name">
                  <input-param :param.sync="param"></input-param>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="게시물 관련 상품 등록">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="상품 검색">
                  <button class="button is-primary"
                          @click="openSelectProduct">상품검색</button>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box">
          <admin-box-item title="상품 정보">
            <div style="overflow-x: auto">
              <div style="min-width:1400px">
                <table class="table">
                  <tbody>
                  <tr class="tr-whole-border">
                    <th style="width: 40px;">id</th>
                    <th style="width: 72px;">상품등록일</th>
                    <th style="width: 40px;">노출여부</th>
                    <th style="width: 80px;">카테고리</th>
                    <th style="width: 64px;">파트너명</th>
                    <th style="width: 84px;">이미지</th>
                    <th style="width: 80px;">상품명</th>
                    <th style="width: 100px;">판매가/기준</th>
                    <th style="width: 40px;">조회</th>
                    <th style="width: 40px;">리뷰</th>
                    <th style="width: 40px;">주문신청</th>
                    <th style="width: 40px;">구매완료</th>
                    <th style="width: 40px;">연관 상품에서 삭제</th>
                  </tr>

                  <tr v-for="(pi, idx) in productTable" :key="'product-item'+idx" class="lp-row many-field-tr">
                    <td>{{ pi.id }}</td>
                    <td>{{ convertDate(pi.created_time, 'datetime') }}</td>
                    <td><span>{{ pi.enable_prod ? '노출함': '노출안함' }}</span></td>
                    <td>{{ pi.category }}</td>
                    <td style="width:60px">{{ pi.partner.name }}</td>
                    <td style="padding: 6px 12px;">
                      <div style="text-align: center;display: inline-block"
                           :style="imgField(pi.first_img)" v-if="pi.first_img"></div>
                      <!-- <div :style="'background-image: url('+image(pi.img)+'); width: 60px; height: 60px; background-size: cover; background-posipion: center;'"></div> -->
                    </td>
                    <td>{{ pi.name }}</td>
                    <td>{{ pi.price.price | currency }} / {{ pi.price.unit }}</td>
                    <td>{{ pi.visit }}</td>
                    <td>{{ pi.review_count }}</td>
                    <td>{{ pi.order_count }}</td>
                    <td><button class="button is-danger" @click="deleteProductItem(idx)">삭제</button></td>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </admin-box-item>
        </div>

        <modal name="productListModal" :adaptive="true" :width="900" height="auto" v-if="enableModal" class="modal-style">
          <product-list @productItems="productItems" page="exhibition" :selectedItems="id_list" style="zoom: 0.85"></product-list>
        </modal>

      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

  </div>
</template>

<script>
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import AdminDatePicker from "../../module/admin/AdminDatePicker";
  import InputImg from "../../module/common/InputImg";
  import LpRadio from "../../module/common/LpRadio";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import InputParam from "../../module/custom/InputParam";
  import ProductList from "../product/ProductList";
  import LpEditor from "../../module/common/LpEditor";

  export default {
    layout: "Main",
    components: {
      LpEditor,
      ProductList,
      InputParam,
      LpAdmDropInput,
      LpRadio,
      AdminDatePicker,
      AdminFormItem,
      AdminBoxItem,
      InputImg
    },
    created() {
      // 새로 등록
      if ( this.$route.query.id === undefined ) {
        /*this.event.start_date = this.resetNewDate('start');
        this.event.end_date = this.resetNewDate('end');
        this.event.username = this.$store.getters.admin.username;*/
        this.getUserList();
      }
      // 라우팅
      else {
        this.getUserList();
        this.getData();
        this.value.start_date = this.convertNewDate(this.value.start_date);
        this.value.end_date = this.convertNewDate(this.value.end_date);
      }
    },
    data() {
      return {
        enableModal: false,
        id_list:[],
        productTable: [],
        // 맞춤 DB
        param_list:[],
        post_param: [],
        value: {
          products: [],
          id: 0,
          enable_post: true,
          start_date: '',
          end_date: '',
          // date: {
          //   min: "2017-01-01",
          //   max: "2099-12-31"
          // },
          priority: 0,
          title: "",
          content: "",
          img: ""
        },
        // 작성자 전체 목록 리스트
        userlist: [],
        post_username: '',
        post_user_id: '',
        post_user_type: '',
      };
    },
    watch: {
      /*modalResponse(n){
        if(n==='close'){
          this.value.products = n.productIdArr;
          this.productTable = n.productTable;
        }
      }*/
    },
    methods: {
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 60px; height: 60px; background-size: cover;' +
          ' background-position: center; ';
      },
      // 상품 정보 리스트
      productItems(res){
        for(let i=0; i<res.id_list.length; i++){
          if(this.id_list.includes(res.id_list[i])===false){
            //this.productIdArr.push(res.id_list[i]);
            this.id_list.push(res.id_list[i]);
            this.productTable.push(res.productItems[i]);
            this.value.products.push(res.id_list[i]);
          }
        }
        //this.$refs.productListModal.close();
        this.$modal.hide('productListModal');
      },
      openSelectProduct(){
        /*let value = {
          productTable: this.productTable,
          productIdArr: this.value.products
        }
        this.$store.commit('openModal', {type: 'modal-select-exhibition-product', value: value, width: '1080'})*/
        //this.$refs.productListModal.open();
        this.$modal.show('productListModal');
      },
      deleteProductItem(idx){
        removeIndex(this.productTable,idx);
        removeIndex(this.value.products,idx);
        removeIndex(this.id_list,idx);
      },
      paramAllList(){
        // 파라미터 리스트
        this.$axios.get('admin/board/post/param').then(res=>{
          if(res.status===200){
            this.param_list = res.data;
            this.paramChecker(this.param_list);
          }
        })
      },
      paramChecker(param){
        if (param.data.length===0){
          return;
        }
        // post_param 상품마다의 파라미터를 의미
        // param = param_list 전체 파라미터 목록
        let id_list = this.post_param.map(item=>{
          return item.param_id;
        })

        param.data.forEach(item=> {
          /* value_
          * param_id
          * param_type
          * choice_items */
          if(!id_list.includes(item.id)){
            // text
            if(item.param_type===0){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_text: '',
                name: item.name
              })
            }
            // integer
            else if(item.param_type===1){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_integer: '',
                name: item.name
              })
            }
            // float
            else if(item.param_type===2){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_float: '',
                name: item.name
              })
            }
            // select
            else if(item.param_type===3){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_select:[],
                name: item.name
              })
            }
            // region
            else if(item.param_type===4){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_region: '',
                name: item.name
              })
            }
            //address
            else if(item.param_type===5){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_address: {
                  sido: '',
                  sigungu: '',
                  dong: '',
                  detail: '',
                  post_code: '',
                  old: '',
                  new: ''
                },
                name: item.name
              })
            }
            // linear
            else if (item.param_type===6){
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_linear: '',
                options: item.options,
                name: item.name
              })
            }
            // date
            else if (item.param_type===7) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_date: '',
                options: item.options,
                name: item.name
              })
            }
            // file
            else if (item.param_type===8) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_files:'',
                options: item.options,
                name: item.name
              })
            }
            // time
            else if (item.param_type===9) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_time: '00:00',
                options: item.options,
                name: item.name
              })
            }
            // datetime
            else if (item.param_type===10) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_date_time: '',
                options: item.options,
                name: item.name
              })
            }
            // daterange
            else if (item.param_type===11) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_date_range: [],
                options: item.options,
                name: item.name
              })
            }
            // datetimerange
            else if (item.param_type===12) {
              this.post_param.push({
                param_id: item.id,
                param_type: item.param_type,
                choice_items: item.choice_items,
                value_date_time_range: '',
                options: item.options,
                name: item.name
              })
            }
          }
        })

      },

      getUserList(){
        this.$axios.get('public/user/whole').then(res=>{
          this.userlist = res.data;

        })
      },
      getUsername(type){
        if (type==='post') {
          if(this.userlist.length>0){
            for(let i=0; i<this.userlist.length; i++){
              if(this.userlist[i].value===this.post_user_id &&
                this.post_user_type===this.userlist[i].type){
                this.post_username = this.userlist[i].name;
                break;
              }
            }
          }
        }
        else if (type==='comment') {
          if(this.userlist.length>0){
            for(let i=0; i<this.userlist.length; i++){
              if(this.userlist[i].value===this.comment_user_id &&
                this.comment_user_type===this.userlist[i].type){
                this.comment_username = this.userlist[i].name;
                break;
              }
            }
          }
        }

      },
      // 게시판 노출 여부
      onSelectedPostState(val) {
        this.value.enable_post = val;
      },
      getData() {
        if (this.$route.query.id) {
          let url = 'board/' + this.$route.params.id + '/mapping/' + this.$route.query.id;
          this.$axios.get(this.getUrl(url))
            .then(res => {
              this.value = res.data.post;

              this.productTable = res.data.post.product_list;

              for(let i=0; i<res.data.post.product_list.length; i++) {
                this.id_list.push(res.data.post.product_list[i].id);
              }

              this.post_param = res.data.params;
              if (res.data.post.user_type === 'admin') {
                this.post_user_type = 'admin';
                this.post_user_id = res.data.post.admin;
              }
              else if (res.data.post.user_type === 'partner') {
                this.post_user_type = 'partner';
                this.post_user_id = res.data.post.partner;
              }
              this.getUsername('post');
              this.paramAllList();

              this.enableModal = true;
            });
        }
        else {
          this.paramAllList();
          this.enableModal = true;
        }
      },
      // 삭제
      clickDelete(item) {
        let url = 'board/' + this.$route.params.id +
          '/post/' + this.$route.query.id + '/comment/' + item.id;
        this.$axios.delete(this.getUrl(url))
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getComment();
            }
          })

      },
      // 뒤로가기 (등록 취소)
      clickBack() {
        this.$router.back();
      },
      done() {
        this.$axios.patch(this.getUrl('board/' +this.$route.params.id + '/mapping/' + this.$route.query.id),{
          products: this.value.products
        }).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            let title = '/mapping?title='+this.$route.query.title;
            this.$router.replace(this.getPath('board/' + this.$route.params.id + title));
          }
        })
      }
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  ////@import '~assets/css/reset';
  @import '~assets/css/lp_main';

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }

  .event-comment-content {
    padding: 20px;
    font-size: 0.95rem;
    color: #222;
    border-radius: 3px;
    border: none;
    background-color: #f2f7f8;
    display: block;
    width: 100%;
    height: 120px;
  }

  .btn-add-img {
    margin: 0 8px 8px 0;
    background: #f2f7f8;
    width: 80px;
    height: 80px;
    text-align: center;
  }

  .btn-add-img i {
    font-size: 3rem;
    line-height: 80px;
    color: #555;
  }

</style>
